module.exports = __webpack_public_path__ + "static/media/march.67f78bdd.jpeg";